

export const BrowserLink = "https://spacepetad1.onelink.me/MLvZ/pcweb";
export const PlayStoreLink = "https://cosmicnyang.page.link/QYkB";
export const AppStoreLink = "https://cosmicnyang.page.link/QYkB";


export const PlayStoreWebLink = "https://spacepetad1.onelink.me/MLvZ/ejggoqow";
export const AppStoreWebLink = "https://spacepetad1.onelink.me/MLvZ/ejggoqow";